export default __webpack_public_path__ + "static/media/bear_pic_1_mobile.2ad3e167.png";